import { Injectable, inject } from '@angular/core';
import {
  CustomFieldDefinition,
  GetCustomFieldDefinitionResponseGQL,
  GetCustomFieldDefinitionResponseQuery,
} from '@graphql';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ObjectName } from '@view-model';
import { ResponseService } from './response.service';

@Injectable({
  providedIn: 'root',
})
export class GetCustomFieldsService {
  private readonly getCustomFieldDefinitionResponseGQL = inject(
    GetCustomFieldDefinitionResponseGQL,
  );
  private readonly responseService = inject(ResponseService);

  getFields(objectName: ObjectName): Observable<CustomFieldDefinition[]> {
    return this.getCustomFieldDefinitionResponseGQL
      .fetch({ variables: { objectName }, fetchPolicy: 'no-cache', errorPolicy: 'all' })
      .pipe(
        switchMap((response) =>
          this.responseService.responseToDataOrError<GetCustomFieldDefinitionResponseQuery>(
            response,
          ),
        ),
        map(
          (response) =>
            response.getCustomFieldDefinitionResponse?.customFieldDefinitionEntryList || [],
        ),
        map((entryList) => entryList?.find((entry) => entry?.objectName === objectName)),
        map((entry) =>
          (entry?.customFieldDefinitionList || []).filter(
            (field): field is CustomFieldDefinition => field != null,
          ),
        ),
      );
  }
}
